<template>
    <b-row>
        <b-col sm="12">
            <b-card>
                <b-row class="pt-sm-1">
                    <b-col sm="1">
                        <span class="card-title wise-card-title">검색 조건</span>
                    </b-col>
                    <b-col sm="1"><strong>검색어</strong></b-col>
                    <b-col sm="8">
                        <b-form-input v-model="queryParams.keyword" placeholder=""
                            v-on:keyup="$event.keyCode === 13 ? findExtReport() : ''"></b-form-input>
                    </b-col>
                    <b-col sm="2" style="text-align: center;">
                        <b-button variant="primary" style="width: 100%;" v-on:click="findExtReport()">검색</b-button>
                    </b-col>
                </b-row>
                <b-row class="pt-sm-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1"><strong>작성일 기간</strong></b-col>
                    <b-col sm="3">
                        <date-picker v-model="fullDateTmp"
                                    type="date"
                                    style="width: 100%;"
                                    range
                                    placeholder="조회기간 선택"
                                    :lang="datepickerLang"
                                    @change="handleDateRangeChange"
                        />
                    </b-col>
                    <b-col sm="6">
                        <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('ALL')">전체</button>
                        <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1WEEK')">1주일</button>
                        <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1MONTH')">1개월</button>
                        <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('6MONTH')">6개월</button>
                        <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('1YEAR')">1년</button>
                    </b-col>
                </b-row>
                <b-row class="pt-sm-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1"><strong>노출여부</strong></b-col>
                    <b-col sm="4" style="display: inline-flex;">
                        <b-form-checkbox v-model="isCheckStatus" style="padding-right: 15px;" @change="allCheckStatus">전체</b-form-checkbox>
                        <b-form-checkbox-group v-model="queryParams.status" @click.native="isCheckStatus = false">
                            <b-form-checkbox value="Y">노출</b-form-checkbox>
                            <b-form-checkbox value="N">비노출</b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-col>
                </b-row>

                <b-row class="pt-sm-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1"><strong>해시태그유무</strong></b-col>
                    <b-col sm="4" style="display: inline-flex;">
                        <b-form-checkbox v-model="isCheckHastags" style="padding-right: 15px;" @change="allCheckHastags">전체</b-form-checkbox>
                        <b-form-checkbox-group v-model="queryParams.hashtags" @click.native="isCheckHastags = false">
                            <b-form-checkbox value="Y">존재</b-form-checkbox>
                            <b-form-checkbox value="N">미존재</b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-col>
                </b-row>

                <b-row class="pt-sm-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1"><strong>관심카테고리</strong></b-col>
                    <b-col sm="10" style="display: inline-flex;">
                        <b-form-checkbox v-model="isCheckCategory" style="padding-right: 15px;" @change="allCheckCategory">전체</b-form-checkbox>
                        <b-form-checkbox-group v-model="queryParams.categorys" @click.native="isCheckCategory = false">
                            <template v-for="(item, index) in interestList">
                                <b-form-checkbox :value="item.item_code">{{item.item_name}}</b-form-checkbox>
                            </template>
                        </b-form-checkbox-group>
                    </b-col>
                </b-row>

                <b-row class="pt-sm-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1"><strong>외부사이트</strong></b-col>
                    <b-col sm="9" class="site_area">
                        <b-form-checkbox v-model="isCheckSite" style="padding-right: 15px;" @change="allCheckSite">전체</b-form-checkbox>
                        <b-form-checkbox-group v-model="queryParams.sites" @click.native="isCheckSite = false">
                            <template v-for="(item, index) in siteList">
                                <b-form-checkbox :value="item.site_id">{{item.site_name}}</b-form-checkbox>
                            </template>
                        </b-form-checkbox-group>
                    </b-col>
                    <b-col sm="1" v-on:click="fnOpenClose()" style="cursor: pointer;">
                        <i v-if="!isOpen" class="fa fa-caret-square-o-up fa-lg"></i>
                        <i v-if="isOpen" class="fa fa-caret-square-o-down fa-lg"></i>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _ from 'lodash'
import swal from 'sweetalert2'

import { EventBus } from "../../../event-bus";

export default {
    name: "extReportSearch",
    props: {
        fullDate: {
            type: Array,
        },
        queryParams: {
            keyword: {
                type: String,
            },
            status: {
                type: Array,
            },
            sites: {
                type: Array,
            },
            categorys: {
                type: Array,
            },
            hashtags: {
                type: Array,
            }
        },
    },
    components: {
        DatePicker,
    },
    mounted() {
        this.fnOpenClose();
        this.findSiteList();
        this.findCodesList();
    },
    data() {
        return {
            datepickerLang: {
                yearFormat: "YYYY년",
                monthFormat: "M월",
                days:["일","월","화","수","목","금","토"]
            },
            fullDateTmp: [],
            siteList: [],       // 사이트 목록
            interestList: [],   // 관심카테고리 목록
            isCheckStatus: false,
            isCheckSite: false,
            isCheckCategory: false,
            isCheckHastags: false,
            isOpen: false,
        }
    },
    methods: {
        // 외부리포트 검색
        findExtReport() {
            // console.log(this.queryParams, this.fullDate);
            EventBus.$emit('callFindExtReport');
        },
        // 사이트 목록
        findSiteList() {
            // /api/select/extSiteList
            var token = sessionStorage.getItem("myToken");
            this.$http.get('/api/select/extSiteList?siteType=report&access_token='+token)
            .then((result) => {
                    const { data } = result;
                    this.siteList = data;
            })
        },
        // 접기 펼치기 버튼
        fnOpenClose() {
            this.isOpen = !this.isOpen;
            if(this.isOpen){
                document.querySelector('.site_area').style.height = '20px';
                document.querySelector('.site_area').style.overflow = 'hidden';
            }else{
                document.querySelector('.site_area').style.height = '';
            }
        },
        // 관심카테고리 목록
        findCodesList() {
            var token = sessionStorage.getItem("myToken");
            // INTEREST_FIELD_CODE(관심분야)
            this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=INTEREST_FIELD_CODE')
            .then((result) => {
                    const { data } = result;
                    this.interestList = data;
            })
        },
        // 날짜 정의
        dateRange(flag) {
            let endDate;
            let startDate;
            if(this.fullDateTmp.length === 0){
                endDate = new Date();
                startDate = new Date();
            }else{
                endDate = this.fullDateTmp[1];
                startDate = _.clone(this.fullDateTmp[1]);
            }

            if(flag == '1WEEK'){
                startDate.setDate(endDate.getDate() - 7);
            }else if(flag == '1MONTH'){
                startDate.setMonth(endDate.getMonth() - 1);
            }else if(flag == '6MONTH'){
                startDate.setMonth(endDate.getMonth() - 6);
            }else if(flag == '1YEAR'){
                startDate.setFullYear(endDate.getFullYear() - 1);
            }
            this.fullDateTmp = [startDate, endDate];
            if(flag == 'ALL'){
                this.fullDateTmp = [];
            }
            this.handleDateRangeChange();
        },
        handleDateRangeChange() {
            this.$parent.fullDate = this.fullDateTmp;
        },
        allCheckStatus(){
            this.isCheckStatus = !this.isCheckStatus;
            if(this.isCheckStatus) {
                this.queryParams.status = ["Y", "N"];
            }else{
                this.queryParams.status = [];
            }
        },
        allCheckSite() {
            this.isCheckSite = !this.isCheckSite;
            if(this.isCheckSite) {
                this.queryParams.sites = [];
                this.siteList.forEach((data) => {
                    this.queryParams.sites.push(data.site_id);
                });
            }else{
                this.queryParams.sites = [];
            }
        },
        allCheckCategory(){
            this.isCheckCategory = !this.isCheckCategory;
            if(this.isCheckCategory) {
                this.queryParams.categorys = [];
                this.interestList.forEach((data) => {
                    this.queryParams.categorys.push(data.item_code);
                });
            }else{
                this.queryParams.categorys = [];
            }
        },
        allCheckHastags() {
            this.isCheckHastags = !this.isCheckHastags;
            if(this.isCheckHastags) {
                this.queryParams.hashtags = ["Y", "N"];
            }else{
                this.queryParams.hashtags = [];
            }
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/views/contents/extReport/component/ExtReportSearch.vue